import {CompaniesState} from "../AppState";
import {AppActions} from "../actions";
import { CLINIC_LIST_UPDATED } from "../actions/WorkforceClinicAction";
import {USER_LOGGED_IN, USER_LOGGED_IN_WRONG_URL} from "../actions/WorkforceOneLoginActions";

function getCleanUserState(): CompaniesState{
    return {
        visibleCompanies: []
    };
}

export default function Workforce1Companies(state = getCleanUserState(), action: AppActions) : CompaniesState {
    switch (action.type) {
        case USER_LOGGED_IN:{
            return {
                ...state,
                visibleCompanies: action.payload.Portal.Clinic
            };
        }
        case CLINIC_LIST_UPDATED:{
          return {
              ...state,
              visibleCompanies: action.payload.Clinic
          };
      }
        case USER_LOGGED_IN_WRONG_URL:{
            return {
                ...state,
                visibleCompanies: action.payload.Portal.Clinic
            };
        }
        default:
            return state
    }
}
